import { render, staticRenderFns } from "./Ueberuns.vue?vue&type=template&id=92537aa2&scoped=true"
import script from "./Ueberuns.vue?vue&type=script&lang=js"
export * from "./Ueberuns.vue?vue&type=script&lang=js"
import style0 from "./Ueberuns.vue?vue&type=style&index=0&id=92537aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92537aa2",
  null
  
)

export default component.exports